export const COMPANY_NAME = 'Jess Gibbons Counselling'